export function WhoItsFor() {
  const audiences = [
    {
      icon: 'ri-quill-pen-line',
      title: 'First-Time Authors',
      description: 'Navigate the publishing journey with expert guidance from manuscript to market launch.'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Self-Published Authors',
      description: 'Elevate your existing work with professional branding and expanded distribution reach.'
    },
    {
      icon: 'ri-presentation-line',
      title: 'Coaches and Consultants',
      description: 'Transform your expertise into a published authority asset that attracts premium clients.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Entrepreneurs',
      description: 'Build credibility and open doors with a professionally published business book.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Thought Leaders',
      description: 'Amplify your message and establish yourself as the go-to expert in your field.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Experts Building Authority',
      description: 'Leverage publishing to gain media visibility, speaking opportunities, and industry recognition.'
    }
  ];

  return (
    <section className="bg-black py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center mb-16">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            Who It's For
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            Built for Modern Authors
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="group bg-gradient-to-b from-[#1C1C1C] to-[#0F0F0F] rounded-2xl p-10 border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all duration-300 hover:transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#D4AF37]/10 mb-6 group-hover:bg-[#D4AF37]/20 transition-colors">
                <i className={`${audience.icon} text-[#D4AF37] text-3xl`}></i>
              </div>
              <h3 className="text-white text-xl font-semibold mb-4">
                {audience.title}
              </h3>
              <p className="text-[#999999] text-base leading-relaxed">
                {audience.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}